module.exports = __webpack_public_path__ + "static/Werewolf-4f2ce7976c7f229330548570ffb59ceb.jpg";